require("./wdh-legacy/center-list-spot/js/base/component-center-list-spot.js");